import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiTarget } = FiIcons;

const About = () => {
  return (
    <div className="bg-white font-inter">
      {/* Hero Section - Updated to a slightly deeper, elegant slate gradient for better definition */}
      <section className="bg-gradient-to-b from-slate-200/50 via-slate-100/20 to-white py-24 border-b border-divider relative overflow-hidden">
        {/* Subtle background decorative element */}
        <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/2 w-96 h-96 bg-primary/5 rounded-full blur-3xl pointer-events-none"></div>
        
        <div className="max-w-6xl mx-auto px-4 relative z-10">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <h1 className="text-4xl md:text-5xl font-extrabold text-primary mb-8 tracking-tight">
              Tentang Akademika Support
            </h1>
            <p className="text-xl md:text-2xl text-secondary max-w-3xl mx-auto leading-relaxed font-medium">
              Partner terpercaya bagi akademisi dalam menyelesaikan pekerjaan teknis publikasi ilmiah dengan standar internasional.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Mission & Integrity Section */}
      <section className="py-24">
        <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 gap-16 lg:gap-24">
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
                <SafeIcon icon={FiTarget} className="text-2xl text-primary" aria-hidden="true" />
              </div>
              <h2 className="text-2xl font-bold text-primary">Misi Kami</h2>
            </div>
            <p className="text-secondary text-lg leading-relaxed font-normal">
              Memberikan dukungan teknis akademik yang berkualitas tinggi, etis, dan terpercaya bagi para dosen, peneliti, dan mahasiswa pascasarjana. Kami percaya bahwa setiap karya akademik layak mendapatkan presentasi terbaik.
            </p>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
                <SafeIcon icon={FiShield} className="text-2xl text-primary" aria-hidden="true" />
              </div>
              <h2 className="text-2xl font-bold text-primary">Integritas</h2>
            </div>
            <p className="text-secondary text-lg leading-relaxed font-normal">
              Kami menjunjung tinggi etika akademik. Layanan kami berfokus pada aspek teknis dan estetika naskah, tanpa mencampuri substansi ilmiah atau melakukan tindakan yang melanggar integritas akademik.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="bg-primary py-24 text-white relative overflow-hidden">
        <div className="max-w-6xl mx-auto px-4 relative z-10">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-12 text-center">
            <motion.div 
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              className="space-y-2"
            >
              <div className="text-5xl font-bold mb-2">500+</div>
              <div className="text-white text-xs font-bold uppercase tracking-[0.2em]">Proyek Selesai</div>
            </motion.div>
            <motion.div 
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="space-y-2"
            >
              <div className="text-5xl font-bold mb-2">200+</div>
              <div className="text-white text-xs font-bold uppercase tracking-[0.2em]">Klien Puas</div>
            </motion.div>
            <motion.div 
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="space-y-2"
            >
              <div className="text-5xl font-bold mb-2">50+</div>
              <div className="text-white text-xs font-bold uppercase tracking-[0.2em]">Jurnal Internasional</div>
            </motion.div>
            <motion.div 
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
              className="space-y-2"
            >
              <div className="text-5xl font-bold mb-2">5</div>
              <div className="text-white text-xs font-bold uppercase tracking-[0.2em]">Tahun Pengalaman</div>
            </motion.div>
          </div>
        </div>
      </section>

      <div className="py-12 bg-white"></div>
    </div>
  );
};

export default About;